import React, { Component } from 'react';
import * as _ from 'lodash';
import Validator from 'validatorjs';
import { Guardian } from '@xaamin/guardian';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Row, Col, Button, DropdownButton, Dropdown } from 'react-bootstrap';

import ConceptosUploadFile from './ConceptosUploadFile';
import CuentaPredialManager from './CuentaPredialManager';
import { FormControl } from '../../../../../facturotopia';
import DecimalAmount from '../../../../../support/DecimalAmount';
import TipoComprobante from '../../../support/enum/TipoComprobante';
import DecimalForConceptos from '../../../support/impuestos/DecimalForConceptos';
import ComplementoConcepto from '../../complementos-concepto/ComplementoConcepto';
import ConceptoImpuestosTrasladosIva from './Impuestos/ConceptoImpuestosTrasladosIva';
import UnidadDeMedidaSuggestions from '../../../../catalogs/UnidadDeMedidaSuggestions';
import ConceptoImpuestosTrasladosIeps from './Impuestos/ConceptoImpuestosTrasladosIeps';
import ConceptoImpuestosRetencionesIsr from './Impuestos/ConceptoImpuestosRetencionesIsr';
import ConceptoImpuestosRetencionesIva from './Impuestos/ConceptoImpuestosRetencionesIva';
import ProductoServicioSuggestions from '../../../../catalogs/ProductoServicioSuggestions';
import ConceptoImpuestosRetencionesIeps from './Impuestos/ConceptoImpuestosRetencionesIeps';

const initialState = {
  TrasladosIva: {
    Impuesto: '002',
    TipoFactor: 'Tasa',
    TasaOCuota: 16,
  },
  TrasladosIeps: {
    Impuesto: '003',
    TipoFactor: undefined,
    TasaOCuota: 0,
  },
  RetencionesIsr: {
    Impuesto: '001',
    TipoFactor: undefined,
    TasaOCuota: 0,
  },
  RetencionesIva: {
    Impuesto: '002',
    TipoFactor: undefined,
    TasaOCuota: 0,
  },
  RetencionesIeps: {
    Impuesto: '003',
    TipoFactor: undefined,
    TasaOCuota: 0,
  },
};

const objectoImpuestosOption = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'No es objeto de impuestos.',
    value: '01',
  },
  {
    label: 'Sí es objeto de impuestos.',
    value: '02',
  },
  {
    label: 'Sí es objeto de impuestos y no obligado al desglose.',
    value: '03',
  },
];
class ConceptoUpsertForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {
        Complemento: undefined,
        ObjetoImp: TipoComprobante.make(props.comprobante.TipoDeComprobante).isTraslado() ? '01' : '02',
        TrasladosIva: {
          ...initialState.TrasladosIva,
        },
        TrasladosIeps: {
          ...initialState.TrasladosIeps,
        },
        RetencionesIsr: {
          ...initialState.RetencionesIsr,
        },
        RetencionesIva: {
          ...initialState.RetencionesIva,
        },
        RetencionesIeps: {
          ...initialState.RetencionesIeps,
        },
      },
      additional: {},
      validations: {},
      validator: new Validator({}, this.rules),
      show: false,
    };
  }

  get rules() {
    const requiredClaveProdServ = Guardian.allows('claveprodserv_requerido.access')
      ? ['required', 'string']
      : ['string'];

    const decimals = DecimalForConceptos.decimales;

    return {
      NoIdentificacion: [],
      Cantidad: ['required', 'numeric', `regex:/^[0-9]{1,18}(.[0-9]{1,${decimals}})?$/`],
      ValorUnitario: ['required', 'numeric', `regex:/^[0-9]{1,18}(.[0-9]{1,${decimals}})?$/`],
      Descuento: ['numeric', `regex:/^[0-9]{1,18}(.[0-9]{1,${decimals}})?$/`],
      Descripcion: ['required'],
      ObjetoImp: ['required'],
      ClaveUnidad: ['string'],
      ClaveProdServ: requiredClaveProdServ,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.comprobante !== this.props.comprobante) {
      if (TipoComprobante.make(this.props.comprobante.TipoDeComprobante).isTraslado()) {
        this.setState({
          data: {
            ...this.state.data,
            ObjetoImp: '01',
          },
        });
      } else {
        this.setState({
          data: {
            ...this.state.data,
            ObjetoImp: '02',
          },
        });
      }
    }

    if (!!this.props.data && prevProps.data !== this.props.data) {
      const complementoConcepto = _.get(this.props.data, 'ComplementoConcepto', []);

      const cuentaPredial = _.get(this.props.data, 'CuentaPredial', []);
      const traslados = _.get(this.props.data, 'Impuestos.Traslados.Traslado', []);
      const retenciones = _.get(this.props.data, 'Impuestos.Retenciones.Retencion', []);

      let trasladosIva = { ...traslados.find((item) => item.Impuesto === '002') };
      let trasladosIeps = { ...traslados.find((item) => item.Impuesto === '003') };

      let retencionesIsr = { ...retenciones.find((item) => item.Impuesto === '001') };
      let retencionesIva = { ...retenciones.find((item) => item.Impuesto === '002') };
      let retencionesIeps = { ...retenciones.find((item) => item.Impuesto === '003') };

      if (!!trasladosIva && trasladosIva.TipoFactor === 'Tasa') {
        trasladosIva.TasaOCuota = parseFloat(trasladosIva.TasaOCuota) * 100;
      }

      if (!!trasladosIeps && trasladosIeps.TipoFactor === 'Tasa') {
        trasladosIeps.TasaOCuota = parseFloat(trasladosIeps.TasaOCuota) * 100;
      }

      if (!!retencionesIsr && retencionesIsr.TipoFactor === 'Tasa') {
        retencionesIsr.TasaOCuota = parseFloat(retencionesIsr.TasaOCuota) * 100;
      }

      if (!!retencionesIva && retencionesIva.TipoFactor === 'Tasa') {
        retencionesIva.TasaOCuota = parseFloat(retencionesIva.TasaOCuota) * 100;
      }

      if (!!retencionesIeps && retencionesIeps.TipoFactor === 'Tasa') {
        retencionesIeps.TasaOCuota = parseFloat(retencionesIeps.TasaOCuota) * 100;
      }

      trasladosIva = trasladosIva || initialState.TrasladosIva;
      trasladosIeps = trasladosIeps || initialState.TrasladosIeps;
      retencionesIsr = retencionesIsr || initialState.RetencionesIsr;
      retencionesIva = retencionesIva || initialState.RetencionesIva;
      retencionesIeps = retencionesIeps || initialState.RetencionesIeps;

      const newData = {
        ObjetoImp: this.props.data.ObjetoImp || '02',
        ...this.props.data,
        TrasladosIva: {
          ...trasladosIva,
        },
        TrasladosIeps: {
          ...trasladosIeps,
        },
        RetencionesIsr: {
          ...retencionesIsr,
        },
        RetencionesIva: {
          ...retencionesIva,
        },
        RetencionesIeps: {
          ...retencionesIeps,
        },
      };

      const additional = {};
      const validations = {};

      if (cuentaPredial.length > 0) {
        additional.CuentaPredial = true;
        validations.isValidCuentaPredial = true;
      }

      let complemento = undefined;
      if (complementoConcepto !== undefined && Object.keys(complementoConcepto).length > 0) {
        complemento = Object.keys(complementoConcepto)[0] ?? undefined;
      }

      const validator = new Validator(newData, this.rules);

      this.setState({
        data: { ...newData, Complemento: complemento, [`isValid_${complemento}`]: true },
        additional,
        validations,
        validator: validator,
        isValid: validator.passes(),
      });
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes(),
    });
  };

  handleOnAdditionalChange = (value, validations) => {
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        ...value,
      },
      validations: {
        ...this.state.validations,
        [validations.name]: validations.isValid,
      },
    });
  };

  handleOnNoTaxesChange = (event) => {
    const { name, checked } = event.target;
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        [name]: checked,
      },
    });
  };

  handleOnAdd = () => {
    const { data } = this.state;

    let updated = _.cloneDeep(data);

    const ivaTrasladado = parseFloat(updated.TrasladosIva.TasaOCuota || 0) / 100;
    const iepsTrasladado = parseFloat(updated.TrasladosIeps.TasaOCuota || 0) / 100;
    const isrRetenido = parseFloat(updated.RetencionesIsr.TasaOCuota || 0) / 100;
    const ivaRetenido = parseFloat(updated.RetencionesIva.TasaOCuota || 0) / 100;
    const iepsRetenido = parseFloat(updated.RetencionesIeps.TasaOCuota || 0) / 100;

    updated.TrasladosIva.TasaOCuota = DecimalAmount.make(ivaTrasladado).toFixed(6);
    updated.TrasladosIeps.TasaOCuota = DecimalAmount.make(iepsTrasladado).toFixed(6);
    updated.RetencionesIsr.TasaOCuota = DecimalAmount.make(isrRetenido).toFixed(6);
    updated.RetencionesIva.TasaOCuota = DecimalAmount.make(ivaRetenido).toFixed(6);
    updated.RetencionesIeps.TasaOCuota = DecimalAmount.make(iepsRetenido).toFixed(6);

    if (updated.TrasladosIeps.TipoFactor === undefined) {
      delete updated.TrasladosIeps;
    }

    if (updated.ObjetoImp === '01') {
      delete updated.TrasladosIva;
    }

    this.props.onUpsert(updated);

    this.setState({
      data: {
        TrasladosIva: {
          ...initialState.TrasladosIva,
        },
        TrasladosIeps: {
          ...initialState.TrasladosIeps,
        },
        RetencionesIsr: {
          ...initialState.RetencionesIsr,
        },
        RetencionesIva: {
          ...initialState.RetencionesIva,
        },
        RetencionesIeps: {
          ...initialState.RetencionesIeps,
        },
      },
      additional: {},
      validator: new Validator({}, this.rules),
      isValid: false,
    });
  };

  handleOnSuggestionSelect = (name) => (item) => {
    const value = item ? item.clave : '';

    let values = {
      [name]: value,
    };

    if (name === 'ClaveUnidad') {
      values.Unidad = !!item ? item.nombre : undefined;
    }

    this.handleOnChange(values);
  };

  handleOnImpuestoTrasladoChange = (data) => {
    let key = '';

    switch (data.Impuesto) {
      case '002':
        key = 'TrasladosIva';
        break;
      case '003':
        key = 'TrasladosIeps';
        break;
      default:
        break;
    }

    this.setState({
      data: {
        ...this.state.data,
        [key]: data,
      },
    });
  };

  handleOnImpuestoRetenidoChange = (data) => {
    let key = '';

    switch (data.Impuesto) {
      case '001':
        key = 'RetencionesIsr';
        break;
      case '002':
        key = 'RetencionesIva';
        break;
      case '003':
        key = 'RetencionesIeps';
        break;
      default:
        break;
    }

    this.setState({
      data: {
        ...this.state.data,
        [key]: data,
      },
    });
  };

  handleOnShow = () => {
    this.setState({
      show: true,
    });
  };

  handleOnClose = (values) => {
    this.setState({
      ...this.state.data,
      ...values,
    });
  };

  handleOnAddFile = (values) => {
    this.props.onAdd(values);
  };

  handleOnComplementoValueChange = (data) => {
    this.setState({
      ...this.state.data,
      ...data,
    });
  };

  handleOnSetComplementoConcepto = (complemento) => {
    const data = {
      ...this.state.data,
      Complemento: complemento,
    };

    this.setState({ data });
  };

  handleOnCalcelComplementoConcepto = (data) => {
    this.setState({ data });
  };

  handleOnAdditionalForm = (controlId, checked, label) => {
    return (
      <Row>
        <Col>
          <Form.Group controlId={controlId}>
            <Form.Check
              type="checkbox"
              name={controlId}
              label={label}
              checked={checked || false}
              onChange={this.handleOnAdditionalCheckboxChange}
            />
          </Form.Group>
        </Col>
      </Row>
    );
  };

  handleOnAdditionalCheckboxChange = (event) => {
    const { name, checked } = event.target;

    if (checked) {
      this.setState({
        ...this.state,
        additional: {
          ...this.state.additional,
          [name]: checked,
        },
        validations: {
          ...this.state.validations,
          ['isValid' + name]: !checked,
        },
      });
    } else {
      const { validations, data } = this.state;

      delete data[name];
      delete validations['isValid' + name];

      this.setState({
        ...this.state,
        additional: {
          ...this.state.additional,
          [name]: checked,
        },
        validations: { ...validations },
        data: { ...data },
      });
    }
  };

  isValidAllAdditionalForms = () => {
    let isValid = false;

    const { validations } = this.state;

    for (const key in validations) {
      if (Object.prototype.hasOwnProperty.call(validations, key)) {
        if (validations[key] === false) {
          isValid = false;
          break;
        }

        isValid = validations[key] ?? false;
      }
    }

    return isValid;
  };

  render() {
    const rules = this.rules;
    const { comprobante } = this.props;
    const { data = {}, isValid, show, validations, additional = {} } = this.state;
    const { CuentaPredial } = additional;

    let isCompleted = isValid;

    if (Object.keys(validations).length > 0) {
      isCompleted = isCompleted && this.isValidAllAdditionalForms();
    }

    if (data.Complemento !== undefined) {
      let isValidComplemento = data[`isValid_${data.Complemento}`];

      isCompleted = isValid && isValidComplemento;
    }

    const isObjectoDeImpuestos = data.ObjetoImp !== '01';

    return (
      <Form autoComplete="off">
        <Row className="py-2">
          <Col>
            <ProductoServicioSuggestions
              autoFocus
              name="ClaveProdServ"
              id="ClaveProdServ"
              label="Clave producto/servicio"
              rules={rules.ClaveProdServ}
              value={data.ClaveProdServ}
              onSelect={this.handleOnSuggestionSelect('ClaveProdServ')}
            />

            {!Guardian.allows('claveprodserv_requerido.access') && (
              <small className="muted">Si no se especifica se usará 01010101</small>
            )}
          </Col>
        </Row>

        <Row>
          <Col
            sm
            md={2}
          >
            <FormControl
              type="number"
              label="Cantidad"
              name="Cantidad"
              placeholder=""
              help=""
              rules={rules.Cantidad}
              value={data.Cantidad}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col>
            <UnidadDeMedidaSuggestions
              label="U. de Medida"
              name="ClaveUnidad"
              rules={rules.ClaveUnidad}
              value={data.ClaveUnidad}
              onSelect={this.handleOnSuggestionSelect('ClaveUnidad')}
            />
          </Col>

          <Col
            sm
            md={2}
          >
            <FormControl
              type="number"
              label="Valor Unitario"
              name="ValorUnitario"
              placeholder=""
              rules={rules.ValorUnitario}
              value={data.ValorUnitario}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={2}
          >
            <FormControl
              type="number"
              label="Descuento"
              name="Descuento"
              placeholder=""
              rules={rules.Descuento}
              value={data.Descuento}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={3}
          >
            <FormControl
              type="text"
              label="Número Identificación"
              name="NoIdentificacion"
              placeholder=""
              help=""
              rules={rules.NoIdentificacion}
              value={data.NoIdentificacion}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col col={12}>
            <FormControl
              as="textarea"
              label="Descripción"
              rows="3"
              name="Descripcion"
              placeholder=""
              rules={rules.Descripcion}
              value={data.Descripcion}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        {this.handleOnAdditionalForm('CuentaPredial', CuentaPredial, 'Incluir cuenta predial')}

        {CuentaPredial && (
          <CuentaPredialManager
            data={data}
            onFormDataChange={this.handleOnAdditionalChange}
          />
        )}

        <FormControl
          type="select"
          label="Objeto de impuestos"
          name="ObjetoImp"
          placeholder=""
          help="¿El concepto es objeto de impuestos?"
          rules={this.rules.ObjetoImp}
          value={data.ObjetoImp}
          options={objectoImpuestosOption}
          onChange={this.handleOnChange}
        />

        {!TipoComprobante.make(comprobante.TipoDeComprobante).isTraslado() && isObjectoDeImpuestos && (
          <Row className="mb-3">
            <Col md={5}>
              <Row>
                <Col>
                  <strong>Traslados</strong>
                </Col>
              </Row>

              <Row>
                <Col
                  xs="auto"
                  sm={6}
                >
                  <ConceptoImpuestosTrasladosIva
                    data={this.state.data.TrasladosIva}
                    onChange={this.handleOnImpuestoTrasladoChange}
                  />
                </Col>

                <Col
                  xs="auto"
                  sm={6}
                >
                  <ConceptoImpuestosTrasladosIeps
                    data={this.state.data.TrasladosIeps}
                    onChange={this.handleOnImpuestoTrasladoChange}
                  />
                </Col>
              </Row>
            </Col>

            <Col md={7}>
              <Row>
                <Col>
                  <strong>Retenciones</strong>
                </Col>
              </Row>

              <Row>
                {TipoComprobante.make(comprobante.TipoDeComprobante).isIngreso() && (
                  <Col md={4}>
                    <ConceptoImpuestosRetencionesIsr
                      data={this.state.data.RetencionesIsr}
                      onChange={this.handleOnImpuestoRetenidoChange}
                    />
                  </Col>
                )}

                <Col md={4}>
                  <ConceptoImpuestosRetencionesIva
                    data={this.state.data.RetencionesIva}
                    onChange={this.handleOnImpuestoRetenidoChange}
                  />
                </Col>

                <Col md={4}>
                  <ConceptoImpuestosRetencionesIeps
                    data={this.state.data.RetencionesIeps}
                    onChange={this.handleOnImpuestoRetenidoChange}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        )}

        <div className="pb-4">
          <div>
            <strong className="text-black text-upper">Complementos concepto</strong>
          </div>

          <Row className="section">
            <Col>
              <div className="pt-2">
                Si deseas agregar un complemento concepto puedes seleccionarlo de la lista.
                <DropdownButton
                  className="pt-2"
                  id="dropdown-complementos"
                  title="Complementos"
                >
                  <Dropdown.Item onClick={this.handleOnSetComplementoConcepto.bind(this, 'instEducativas')}>
                    Instituciones Educativas
                  </Dropdown.Item>

                  <Dropdown.Item onClick={this.handleOnSetComplementoConcepto.bind(this, 'HidroYPetro')}>
                    Hidro y Petro
                  </Dropdown.Item>

                  {/* Descomentar para agregar en la lista de complemento concepto */}
                  {/* <Dropdown.Item onClick={ this.handleOnSetComplementoConcepto.bind(this, 'VentaVehiculos') }>
                    Venta Vehiculos
                  </Dropdown.Item> */}
                </DropdownButton>
              </div>
            </Col>
          </Row>
        </div>

        <Row>
          <Col col={12}>
            <ComplementoConcepto
              data={data}
              onChange={this.handleOnComplementoValueChange}
              onCancel={this.handleOnCalcelComplementoConcepto}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Button
              variant="secondary"
              disabled={!isCompleted}
              onClick={this.handleOnAdd}
            >
              Agregar concepto
            </Button>
          </Col>

          {Guardian.allows('excel_conceptos.access') && (
            <Col className="text-right">
              <span className="pl-4">
                <Button
                  variant="secondary"
                  onClick={this.handleOnShow}
                >
                  <FontAwesomeIcon icon={['fas', 'upload']} /> Usar excel
                </Button>
              </span>
            </Col>
          )}
        </Row>

        {!!show && (
          <ConceptosUploadFile
            data={comprobante}
            show={show}
            onAdd={this.handleOnAddFile}
            onClose={this.handleOnClose}
          />
        )}

        {this.props.children}
      </Form>
    );
  }
}

export default ConceptoUpsertForm;
